import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
      const { t, i18n } = useTranslation();
    
    return (
        <React.Fragment>
            <footer className="footer galaxy-border-none">
                <Container fluid>
                    <Row style={{ direction: 'ltr'}}>
                        <Col sm={6}>
                            {new Date().getFullYear()} © {t("Alitqan AI")} .
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                {t("FooterTitle")} 
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;